import { type PositionOut, positionsApi, refKeys } from '@/features/references/api'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

export const positionsListQuery = () =>
  typedSuspenseOptions<readonly PositionOut[]>({
    queryKey: refKeys.positions(),
    queryFn: ({ signal }) => positionsApi.list(signal),
    staleTime: 30_000,
  })
